import Formsy, { addValidationRule } from 'formsy-react';
import {
    validBankAcctRegex,
    validSwiftCodeRegex,
    validateZipRegex,
    validSSNRegex,
    validTAXID,
    validPhoneNumber
} from '../constants/Regex';

const splitName = (name) => {
    if (!name) return [];
    return name.split(/ +/);
};

const checkSignature = (firstName = '', lastName = '', sig = '') => {
    const name = splitName(`${firstName.toLowerCase()} ${lastName.toLowerCase()}`.trim());
    const signature = splitName(sig.toLowerCase().trim());
    return name.join('') === signature.join('');
};

addValidationRule('isValidBandAccountNo', (values, value) => {
    if (value) {
        return validBankAcctRegex.test(value);
    }
    return true;
});

addValidationRule('isValidSSN', (values, value) => {
    if (value) {
        return validSSNRegex.test(value);
    }
    return true;
});

addValidationRule('isValidTAXID', (values, value) => {
    if (value) {
        return validTAXID.test(value);
    }
    return true;
});

addValidationRule('isValidSwiftCode', (values, value) => {
    if (value) {
        return validSwiftCodeRegex.test(value);
    }
    return true;
});

addValidationRule('isValidZip', (values, value) => {
    if (value) {
        return validateZipRegex.test(value);
    }
    return true;
});

addValidationRule('validRoutingNumber', (values, value) => {
    if (!value) {
        return true;
    }

    // all valid routing numbers are 9 numbers in length
    if (value.length !== 9) {
        return false;
    }

    // routing numbers starting with 5 are internal routing numbers
    // usually found on bank deposit slips
    if (value[0] === '5') {
        return false;
    }

    if (values.foreignBank === 'true') {
        return value.length === 9;
    }

    // http://en.wikipedia.org/wiki/Routing_transit_number#MICR_Routing_number_format
    const checksumTotal =
        7 * (parseInt(value.charAt(0), 10) + parseInt(value.charAt(3), 10) + parseInt(value.charAt(6), 10)) +
        3 * (parseInt(value.charAt(1), 10) + parseInt(value.charAt(4), 10) + parseInt(value.charAt(7), 10)) +
        9 * (parseInt(value.charAt(2), 10) + parseInt(value.charAt(5), 10) + parseInt(value.charAt(8), 10));

    const checksumMod = checksumTotal % 10;
    return checksumMod === 0;
});

addValidationRule('isValidPhoneNumber', (values, value) => {
    if (value) {
        return validPhoneNumber.test(value);
    }
    return true;
});

addValidationRule('isValidSignature', (values, value) => {
    const {firstName, lastName} = values;
    return checkSignature(firstName, lastName, value);
});

addValidationRule('isValidGuardianSignature', (values, value) => {
    const {guardianFirstName, guardianLastName} = values;
    return checkSignature(guardianFirstName, guardianLastName, value);
});

export default Formsy;
